"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUserRole = void 0;
var EUserRole;
(function (EUserRole) {
    EUserRole[EUserRole["ADMINISTRATOR"] = 0] = "ADMINISTRATOR";
    EUserRole[EUserRole["ANIMATOR"] = 1] = "ANIMATOR";
})(EUserRole || (EUserRole = {}));
exports.EUserRole = EUserRole;
